var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import "pixi.js";
import { eventsStore } from "../../events/eventsStore";
import { shallowDiffers } from "../../utils/shallowDiffers";
var Container = PIXI.Container;
/**
 * Base class for binding canvas/pixi components to the Redux store.
 *
 * @export
 * @class CanvasConnectedComponent
 * @extends {Container}
 * @template TypeState Type of state that component should return from mapState method
 * @template TypeDispatch Type of actions mapped to dispatch function component should return from mapDispatch method
 */
var CanvasConnectedComponent = /** @class */ (function (_super) {
    __extends(CanvasConnectedComponent, _super);
    function CanvasConnectedComponent() {
        var _this = _super.call(this) || this;
        _this.update = function (props) { return undefined; };
        _this.shouldUpdate = function (props, previousProps) { return undefined; };
        _this.dispose = function () { return _this; };
        _this.mapState = function (state) { return state; };
        _this.mapDispatch = function (dispatch) { return ({}); };
        _this.cleanupChild = function (display) {
            if (display == undefined) {
                return;
            }
            if (display.parent != undefined) {
                display.parent.removeChild(display);
            }
        };
        _this._shouldUpdate = function (state, previousState) {
            var shouldUpdate = _this.shouldUpdate(state, previousState);
            var shown = _this.parent && _this.visible && _this.renderable;
            if (shouldUpdate == undefined) {
                return shown && shallowDiffers(state, previousState);
            }
            return shown && shouldUpdate;
        };
        _this._dispose = function () {
            _this.subscription.unsubscribe();
            _this.dispose();
            if (!_this._destroyed) {
                _this.destroy();
            }
            return _this;
        };
        _this.onStoreUpdate = function (store) {
            var state = _this.mapState(store.getState());
            var props = __assign({}, state, _this.mapDispatch(store.dispatch));
            var shouldUpdate = _this._shouldUpdate(props, _this._props);
            _this._props = props;
            if (shouldUpdate) {
                _this.update(props);
            }
        };
        _this.subscription = eventsStore.storeUpdate$.subscribe(_this.onStoreUpdate);
        return _this;
    }
    CanvasConnectedComponent.prototype.destroy = function (options) {
        _super.prototype.destroy.call(this, options);
        this._dispose();
    };
    Object.defineProperty(CanvasConnectedComponent.prototype, "props", {
        get: function () {
            return this._props;
        },
        enumerable: true,
        configurable: true
    });
    return CanvasConnectedComponent;
}(Container));
export { CanvasConnectedComponent };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/CanvasConnectedComponent.ts
// module id = 408
// module chunks = 3